module.exports = __webpack_public_path__ + "static/media/meter3.498fc47c.svg";